import { useTranslation } from 'react-i18next'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'
import { Briefcase, Users, GraduationCap, Heart } from 'lucide-react'

export function JobListings() {
  const { t } = useTranslation()

  // No current openings
  const hasOpenings = false

  return (
    <Section>
      <Container>
        <SectionTitle
          title={t('careers.openings.title')}
          subtitle={t('careers.openings.subtitle')}
          centered
        />

        {!hasOpenings ? (
          <div className="text-center py-12 bg-primary/5 rounded-lg">
            <Briefcase className="w-16 h-16 text-primary mx-auto mb-4" />
            <p className="text-gray-600 text-lg">
              {t('careers.openings.noOpenings')}
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {/* Job listings would go here */}
          </div>
        )}
      </Container>
    </Section>
  )
}

export function WhyJoinUs() {
  const { t } = useTranslation()

  const benefits = [
    { key: 'team', icon: Users },
    { key: 'growth', icon: GraduationCap },
    { key: 'training', icon: Briefcase },
    { key: 'welfare', icon: Heart },
  ]

  return (
    <Section variant="primary">
      <Container>
        <SectionTitle
          title={t('careers.whyUs.title')}
          centered
        />

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {benefits.map((benefit) => (
            <div key={benefit.key} className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-primary rounded-full flex items-center justify-center">
                <benefit.icon className="w-8 h-8 text-dark" />
              </div>
              <h3 className="font-semibold text-dark">
                {t(`careers.whyUs.${benefit.key}`)}
              </h3>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  )
}
